export default __webpack_public_path__ + "static/media/STOMACHACHE.6c131062.png";